import {create} from "zustand";

export type StoreState = {
    expiry: number | null;
    showSmsCodeField: boolean;
    smsMessage: string;

    actions: {
        setExpiry: (expiry: number | null) => void;
        setShowSmsCodeField: (showSmsCodeField: boolean) => void;
        setSmsMessage: (smsMessage: string) => void;
        reset: () => void;
    };
};

export const loginStore = create<StoreState>((set) => ({
    expiry: null,
    showSmsCodeField: false,
    smsMessage: "",

    actions: {
        setExpiry: (expiry) => set({expiry}),
        setShowSmsCodeField: (showSmsCodeField) => set({showSmsCodeField}),
        setSmsMessage: (smsMessage) => set({smsMessage}),
        reset() {
            set({
                expiry: null,
                showSmsCodeField: false,
                smsMessage: "",
            });
        }
    },
}));
